import React from 'react'

function Card(props) {
  return (
    <div style={{display:"flex" , justifyContent:'center'} }>
    <div className="card shadow-lg" style={props.theme}>
    <div className="img"><img src={props.img} alt="" className='imge img-fluid' /></div>
    <div className="user">
    <h5 className='p-3'>Photo by {props.author}</h5>
    </div>
    <ul className='none'>
    <li className='p-1'> <i className="fa-regular fa-eye"></i> <strong>{props.views}</strong></li>
    <li className='p-1'> <i className="fa fa-download"></i> <strong>{props.downloads}</strong></li>
    
    <li className='p-1'><i className="fa-regular fa-thumbs-up"></i> <strong>{props.likes}</strong></li>
    </ul>
   <div className="bottom-flex">
   <div className="tags">
     <span className='tag'>{props.tag1}</span>
     <span className='tag'>{props.tag2}</span>
     <span className='tag'>{props.tag3}</span>
    </div>
    <div className="btnD">
    <a href={props.url} target="_blank" rel='noreferrer'><i className="fa-solid fa-circle-down" id='big' ></i></a>
    </div>
   </div>
    
  </div>
  </div>
  )
}

export default Card